import {User} from '@models/user';

export class AppState {
  constructor(
    public user: User | null = null,
    public token: string | null = null,
    public url: string | null = null,
    public sessionTimeout: string | null = null,
    public language: string | null = null,
  ) {
  }
}
